import Img1 from '../Assets/pexel1.jpg'
import Img2 from '../Assets/pexel2.jpg'
import Img3 from '../Assets/pexel3.jpg'
import Img4 from '../Assets/pexel4.jpg'


const Blogs = [
    {
        id: 1,
        title:"Morbi in sem quis dui placerat mfngauris.",
        Date: "March 1, 2022",
        Comment: "3 Comments",
        img: Img1,
      
    },
    {
        id: 2,
        title:"Aliquam porttitor mfgauris sit ametorci.",
        Date: "August 5, 2021",
        Comment: "1 Comment",
        img: Img2,
       
    },
    {
        id: 3,
        title:"Cras ornare tristiqdue morbi sem elit.",
        Date: "December 18, 2020",
        Comment: "1 Comment",
        img: Img3,
      
    },
  
    {
        id: 4,
        title:"Donec connfsectetuer ligula vulputate sem cursus.",
        Date: "May 9, 2021",
        Comment: "2 Comments",
        img: Img4,
       
    }
]

export default Blogs;